import { put, call, takeLatest } from "redux-saga/effects";
import { fetchNoteSettings, updateNoteSettings } from "./noteSettingsApi";
import { fetchNoteSettingsError, fetchNoteSettingsSuccess, updateNoteSettingsError, updateNoteSettingsRequest, updateNoteSettingsSuccess } from "./noteSettingsSlice";
import { fetchNoteSettingsRequest } from "./noteSettingsSlice";
import { toNoteSettingsResponseParser, toUpdateNoteSettingsRequestObject } from "./noteSettingsMapper";

export  function* updateNoteSettingsSaga(action) {
  try {
    const response = yield call(updateNoteSettings, toUpdateNoteSettingsRequestObject(action.payload));
    yield put(updateNoteSettingsSuccess(true));
  } catch (error) {
    yield put(
      updateNoteSettingsError(
        error.message || "Failed to fetch org access list"
      )
    );
  }
}

export function* fetchNoteSettingsSaga(action) {
  try {
    const response = yield call(fetchNoteSettings);
    yield put(fetchNoteSettingsSuccess(toNoteSettingsResponseParser(response)));
  } catch (error) {
    yield put(
      fetchNoteSettingsError(
        error.message || "Failed to fetch org access list"
      )
    );
  }
}


export default function* noteSettingsSaga() {
  yield takeLatest(
    updateNoteSettingsRequest.type,
    updateNoteSettingsSaga
  );
  yield takeLatest(
    fetchNoteSettingsRequest.type,
    fetchNoteSettingsSaga
  );
}
